import React, { useEffect, useState } from 'react';
import { Heading } from '@jobber/components/Heading';
import Table from './Table/ApprovedTable';
import { useDispatch, useSelector } from 'react-redux';
import { getFromServer } from '../../components/Common/requests';
import { addUniqueIds } from '../../components/Common/Validations';
import { setAllTags, setLineItems, setTitles } from '../../store/tagsSlice';
import { showToast } from '@jobber/components/Toast';
import ResetSidebar from '../../components/Common/ResetSidebar';
import { JobProvider } from './contextAPI/JobContext';
import NewApprovedTable from './Table/NewQuotesTable';
import InstructionToolTip from '../../components/PageInformation/instruction';
import { AutomationFilterProvider } from './FilterQuery/AutomationFilterQuery';

function ApprovedQuotes() {
  const dispatch = useDispatch();
  const tagSlice = useSelector((store) => store.tag);

  useEffect(() => {
    const init = async () => {
      const [result, lineItems] = await Promise.all([getFromServer('Client-Tags'), getFromServer('line-items')]);
      if (result.status) {
        const addUniqueId = addUniqueIds(result.data);
        dispatch(setAllTags(addUniqueId));
      } else {
        showToast({
          message: result.message || result.error,
          variation: 'error'
        });
      }
      if (lineItems.status) {
        console.log(lineItems.data?.lineItems);
        dispatch(setLineItems(lineItems.data?.lineItems));
        dispatch(setTitles(lineItems.data?.quoteTitles));
      } else {
        showToast({
          message: lineItems.message || lineItems.error,
          variation: 'error'
        });
      }
    };
    if (tagSlice?.allTags?.length <= 0 || tagSlice?.lineItems?.length <= 0) {
      init();
    }
  }, []);

  return (
    <AutomationFilterProvider
      filterStorageKey="tempApprovedQuotesFilter"
      pageStorageKey="approvedQuotesTPn"
    >
      <ResetSidebar />
      <div className="row">
        <div>
          <div className="d-flex justify-content-between">
            <Heading level={1}>Approved Quotes</Heading>
            <InstructionToolTip pageurl="pageinstructions" pageName="quote-approved" />
          </div>
          <JobProvider>
            {/* <Table reload={() => { }} /> */}
            <NewApprovedTable />
          </JobProvider>
        </div>
      </div>
    </AutomationFilterProvider>
  );
}

export default ApprovedQuotes;
